<template>
  <div class="page">
    <div class="bg">
      <!-- <header class="back" @click="$router.back()">
        <i class="mintui mintui-back icon_font"></i>
        <span>返回</span>
      </header> -->
      <div class="doctor-top">
        <div class="doc-name">
          <span class="name">{{doctorExpertVO.name}}</span>
          <span class="leave">{{doctorExpertVO.position}}</span>
        </div>
        <div class="hos">
          <div class="dept">{{doctorExpertVO.realDepartment}}</div>
          <div class="hos-name">{{doctorExpertVO.hospital}}</div>
        </div>
        <div class="doc-header">
          <DocHeader v-if="doctorExpertVO.portraitUrl" :portraitUrl="doctorExpertVO.portraitUrl.replace(/ebaiyihui/g,'chinachdu')" :workingYears="doctorExpertVO.workingYears"/>
        </div>
      </div>
      <div class="goodAt">
        <p class="title">擅长领域</p>
        <p class="text">{{doctorExpertVO.expertiseAreas}}</p>
      </div>
      <h3 class="title">个人简介</h3>
      <div class="content">
        <div class="doc-info">
          <p class="p">{{doctorExpertVO.personalProfile}}</p>
          <!-- <p class="p">神经内科 教授，主任医师，博士研究生导师。</p> -->
        </div>
        <div class="div">
          <p class="title">执业经历：</p>
          <ul class="ul">
            <li
              class="li"
              v-for="item of doctorExpertVO.showPractisingExperienceVOList"
              :key="item.id">{{item.practisingExperience}}</li>
          </ul>
          <p class="title">个人成就：</p>
          <p class="p">{{doctorExpertVO.achievement}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DocHeader from './doctorHeader';
import { ready, error } from './static/tool';
export default {
  components: {DocHeader},
  data(){
    return {
      departmentVO: {},
      doctorExpertVO: {}
    }
  },
  methods: {
    async getPageData() {
      try {
        const {id} = this.$route.params
        const {code, data, msg} = await this.$HTTP.GET('https://ihos.chinachdu.com/cloud/consultation/api/show/getExpertDetail', {params:{doctorExpertId: id}});
        if(code !== '1') {
          this.$toast({message: msg});
          return
        }
        const {departmentVO,doctorExpertVO} = data;
        this.departmentVO = departmentVO;
        this.doctorExpertVO = doctorExpertVO;
      } catch (error) {
        throw error;
      }
    }
  },
  created(){
    this.getPageData();
    ready();
    error();
  }
}
</script>

<style lang="less" scoped>
@import './static/detail.less';
</style>
